import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Field } from '@ontruck/orc';
import ButtonLoading from '../ButtonLoading';

const BiddingField = ({
  className,
  handleClick,
  value,
  currencySymbol,
  loading,
  disabled,
  onChange,
  onCancelClick,
  disabledButton,
  ...rest
}) => {
  const { t } = useTranslation('OfferDetail');

  const handleOnChange = (_, target) => {
    return onChange(target.value);
  };

  return (
    <div className={className} data-testid="bidding-field">
      <div className="bidding-field" {...rest}>
        <label className="bidding-field__form-label" htmlFor="bidding_amount">
          {`${t('biddingTitle')}:`}
        </label>
        <Field
          id="bidding_amount"
          name="bidding-amount"
          className={'bidding-field__form-input'}
          size="M"
          value={value}
          asideRightText={currencySymbol}
          disabled={disabled}
          onChange={handleOnChange}
        />
        <ButtonLoading
          testId="bidding-field-button"
          loading={loading}
          disabled={disabled || disabledButton}
          handleClick={handleClick}
          className="bidding-field__actions-primary"
          text={t('bidRequest')}
        />
        <Button
          nude
          skin="primary"
          text={t('cancel')}
          onClick={onCancelClick}
        />
      </div>
    </div>
  );
};

BiddingField.defaultProps = {
  className: '',
  size: 'M',
  disabledButton: false,
  disabled: false
};
BiddingField.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabledButton: PropTypes.bool,
  disabled: PropTypes.bool
};

export default BiddingField;
